// extracted by mini-css-extract-plugin
export var container = "_dc-1";
export var cornerButtonContainer = "_dc-6";
export var disabled = "_dc-2";
export var dragActive = "_dc-3";
export var fileContainer = "_dc-5";
export var hiddenInput = "_dc-4";
export var widthContainer = "_dc-0";